import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M21.67,2.71v9.7A4.4,4.4,0,0,1,17.26,8V6.27h-1.8a4.41,4.41,0,0,1-4.41-4.41h9.77A.85.85,0,0,1,21.67,2.71Zm-6.61,4H6.22a4.41,4.41,0,0,0,4.41,4.4h1.8v1.74a4.4,4.4,0,0,0,4.4,4.41V6.73H15.06Zm-3.91,4.86H1.39A4.41,4.41,0,0,0,5.8,16H7.6v1.73A4.42,4.42,0,0,0,12,22.14v-9.7A.85.85,0,0,0,11.15,11.59Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const LogoJiraIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'logoJira'),
) as IconWithRender;

LogoJiraIcon.displayName = 'LogoJiraIcon';
LogoJiraIcon.propTypes = Icon.propTypes;
LogoJiraIcon.renderIcon = (props) => <LogoJiraIcon {...props} />;
export default LogoJiraIcon;
